import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const QuizHome = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [quizid, setQuizid] = useState("");
  const [participantEmail, setParticipantEmail] = useState("");

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const quizid = searchParams.get("q");
    const participantEmail = searchParams.get("p");

    setQuizid(quizid || "");
    setParticipantEmail(participantEmail || "");

    localStorage.setItem("quizid", quizid);
    localStorage.setItem("participantEmail", participantEmail);
  }, [location.search]);

  return (
    <div className="fade-in" style={{ maxWidth: "800px", margin: "0 auto", padding: "2rem 1rem" }}>
      <div className="card" style={{ padding: "3rem 2rem" }}>
        <div style={{ textAlign: "center", marginBottom: "2rem" }}>
          <h1
            style={{
              fontSize: "2.5rem",
              fontWeight: "700",
              marginBottom: "1rem",
              background: "linear-gradient(135deg, var(--primary-purple-light), var(--accent-cyan))",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            Assessment Instructions
          </h1>
          <p style={{ color: "var(--text-muted)", fontSize: "1.125rem" }}>
            Please read carefully before starting
          </p>
        </div>

        <div style={{ background: "rgba(245, 158, 11, 0.1)", border: "1px solid var(--warning-amber)", borderRadius: "8px", padding: "1rem", marginBottom: "2rem", color: "var(--warning-amber)" }}>
          ⚠️ <strong>Important:</strong> Please do not refresh the page or press F5 during the assessment.
        </div>

        <div style={{ marginBottom: "2rem", fontSize: "1.05rem", lineHeight: "1.7" }}>
          <p style={{ marginBottom: "1rem" }}>
            There are <strong>20 situations</strong> in this assessment. Each situation has 4 possible responses.
            Rank all four responses based on how well they describe you:
          </p>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "1rem", marginBottom: "2rem" }}>
            <div style={{ background: "rgba(15, 23, 42, 0.5)", padding: "1rem", borderRadius: "8px", border: "1px solid var(--border)", textAlign: "center" }}>
              <span style={{ fontSize: "1.5rem", fontWeight: "700", color: "var(--accent-cyan)", display: "block", marginBottom: "0.5rem" }}>1</span>
              Most Like You
            </div>
            <div style={{ background: "rgba(15, 23, 42, 0.5)", padding: "1rem", borderRadius: "8px", border: "1px solid var(--border)", textAlign: "center" }}>
              <span style={{ fontSize: "1.5rem", fontWeight: "700", color: "var(--primary-purple-light)", display: "block", marginBottom: "0.5rem" }}>2</span>
              More Like You
            </div>
            <div style={{ background: "rgba(15, 23, 42, 0.5)", padding: "1rem", borderRadius: "8px", border: "1px solid var(--border)", textAlign: "center" }}>
              <span style={{ fontSize: "1.5rem", fontWeight: "700", color: "var(--accent-pink)", display: "block", marginBottom: "0.5rem" }}>3</span>
              Less Like You
            </div>
            <div style={{ background: "rgba(15, 23, 42, 0.5)", padding: "1rem", borderRadius: "8px", border: "1px solid var(--border)", textAlign: "center" }}>
              <span style={{ fontSize: "1.5rem", fontWeight: "700", color: "var(--text-muted)", display: "block", marginBottom: "0.5rem" }}>4</span>
              Least Like You
            </div>
          </div>

          <ul style={{ listStyle: "none", padding: 0, display: "grid", gap: "1rem" }}>
            <li style={{ display: "flex", gap: "1rem", alignItems: "flex-start" }}>
              <span style={{ color: "var(--accent-cyan)", fontSize: "1.25rem" }}>•</span>
              <span>You have <strong>30 minutes</strong> to complete the assessment.</span>
            </li>
            <li style={{ display: "flex", gap: "1rem", alignItems: "flex-start" }}>
              <span style={{ color: "var(--accent-cyan)", fontSize: "1.25rem" }}>•</span>
              <span>Use each rank (1, 2, 3, 4) exactly once per situation.</span>
            </li>
            <li style={{ display: "flex", gap: "1rem", alignItems: "flex-start" }}>
              <span style={{ color: "var(--accent-cyan)", fontSize: "1.25rem" }}>•</span>
              <span>There are no right or wrong answers. Be honest about your preferences.</span>
            </li>
            <li style={{ display: "flex", gap: "1rem", alignItems: "flex-start" }}>
              <span style={{ color: "var(--accent-cyan)", fontSize: "1.25rem" }}>•</span>
              <span>If you want to change your ranking for a question, click the <strong>RESET</strong> button to clear your selection.</span>
            </li>
          </ul>
        </div>

        <button
          className="btn-primary"
          style={{ width: "100%", padding: "1rem", fontSize: "1.25rem" }}
          onClick={() => navigate("/quiz/start")}
        >
          Start Assessment
        </button>
      </div>
    </div>
  );
};

export default QuizHome;
